module.exports = __webpack_public_path__ + "img/cocktail.5e1fb700.png";